// @generated par rbac-codegen depuis rbac.yaml — NE PAS ÉDITER À LA MAIN.
//
// Miroir strict du modèle backend (`src/auth/permissions.rs`), lui aussi
// généré depuis rbac.yaml : les deux côtés ne peuvent pas diverger.

/** Modules RBAC (miroir de `Module` côté Rust). */
export type PermissionModule =
  | "training"
  | "commercial"
  | "crm"
  | "hr"
  | "qualiopi"
  | "jury"
  | "documents"
  | "templates"
  | "messaging"
  | "admin"
  | "reports"
  | "settings"

/** Opérations RBAC (miroir de `Operation` côté Rust). */
export type PermissionOperation =
  | "read"
  | "write"
  | "delete"
  | "export"
  | "transition"
  | "generate"

/** Rôles qui contournent toute vérification de permission (miroir de `ADMIN_ROLES` côté Rust). */
export const ADMIN_ROLES = ["ADMIN"] as const
